
import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import TableContainer from '@material-ui/core/TableContainer';
import { Link } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';
import Layout from 'components/Dashboard/Layout';
import { YellowButtonMenu } from 'ui/ButtonMenu';
import { ListProvider, ListContext } from 'core/ListProvider';
import TableListFooter from 'core/TableListFooter';
import SearchWidget from 'form/SearchWidget';
import { TariffListTable } from './ListTable';
import { AsyncSelectButtonGroupWidget, SelectButtonGroupWidget } from 'form/SelectButtonGroupWidget';
import { UserContext, hasAccountPermission } from 'components/User';
import { ResponsiveTable } from 'ui/Table';


const TariffListRight = (props) => {
  const { userContext } = props;

  let addButton = undefined;
  if (hasAccountPermission(userContext, 'tariff.add_tariff')) {
    addButton = (
      <YellowButtonMenu component={'div'} label={'Создать тариф'} startIcon={<AddIcon />}>
        <MenuItem component={Link} to={`/tariff/add_base`}>Базовый</MenuItem>
        <MenuItem component={Link} to={`/tariff/add_individual`}>Индвидуальный</MenuItem>
      </YellowButtonMenu>
    );
  }

  return (
    <React.Fragment>
      {addButton}
    </React.Fragment>
  )
};


export default class TariffList extends Component {

  static contextType = UserContext;

  componentDidMount() {
    document.title = 'Тарифы';
  }

  onDetail = (item) => {
    if (item.resourcetype === 'TariffBase') {
      this.props.history.push(`/tariff/base/${item.id}`);
    }
    else if (item.resourcetype === 'TariffIndividual') {
      this.props.history.push(`/tariff/individual/${item.id}`);
    }
  };

  onAddAndCopy = (tariff) => {
    if (tariff.resourcetype === 'TariffBase') {
      this.props.history.push(`/tariff/add_base/${tariff.id}`);
    }
    else if (tariff.resourcetype === 'TariffIndividual') {
      this.props.history.push(`/tariff/add_individual/${tariff.id}`);
    }
  };

  render() {
    return (
      <ListProvider
        url={'tariff'}
        filterInitial={{
          is_archive: false
        }}
      >
        <ListContext.Consumer>
          {context => {
            const { items, permissions } = context;

            return (
              <Layout>

                <Layout.Header
                  title={'Тарифы'}
                  search={
                    <SearchWidget
                      value={context.filter.q}
                      onChange={(value) => context.setFilterValue('q', value)}
                    />
                  }
                  right={
                    <TariffListRight
                      context={context}
                      userContext={this.context}
                      onAddIndividual={this.onAddIndividual}
                      onAddBase={this.onAddBase}
                    />
                  }
                />

                <Layout.Filter>
                  <SelectButtonGroupWidget
                    value={context.filter.is_archive}
                    options={[
                      {value: false, label: 'Актуальные'},
                      {value: true, label: 'Архивные'},
                    ]}
                    onChange={(value, option) => context.setFilterValue('is_archive', value)}
                  />
                  <AsyncSelectButtonGroupWidget
                    url={'catalog/choice'}
                    filter={{
                      type: 'CARRIER'
                    }}
                    defaultOptions={[
                      {id: null, label: 'Все', name: 'Все'}
                    ]}
                    value={context.filter.carrier}
                    onChange={(value) => context.setFilterValue('carrier', value)}
                  />
                  <SelectButtonGroupWidget
                    value={context.filter.polymorphic_ctype__model}
                    options={[
                      {value: null, label: 'Все'},
                      {value: 'tariffbase', label: 'Базовый'},
                      {value: 'tariffindividual', label: 'Индивидуальный'},
                    ]}
                    onChange={(value, option) => context.setFilterValue('polymorphic_ctype__model', value)}
                  />
                </Layout.Filter>

                <Layout.ContentSimple>
                  <TableContainer component={Paper}>
                    <ResponsiveTable>
                      <TariffListTable
                        items={items}
                        onDetail={this.onDetail}
                        onAddAndCopy={this.onAddAndCopy}
                        hasChangePermission={permissions.change}
                      />
                      <TableListFooter colspan={6} />
                    </ResponsiveTable>
                  </TableContainer>
                </Layout.ContentSimple>
              </Layout>
            )
          }}
        </ListContext.Consumer>
      </ListProvider>
    )
  }
}
